// extracted by mini-css-extract-plugin
export var actions = "_ls-d";
export var benefitCard = "_ls-a";
export var benefitIcon = "_ls-b";
export var benefitLabel = "_ls-c";
export var benefits = "_ls-9";
export var bodyText = "_ls-8";
export var closeButton = "_ls-2";
export var content = "_ls-3";
export var eyebrow = "_ls-4";
export var heading = "_ls-5";
export var image = "_ls-f";
export var imagePanel = "_ls-e";
export var modal = "_ls-0";
export var shell = "_ls-1";
export var title = "_ls-6";
export var titleOffer = "_ls-7";